// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonNone_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s12IconSvg = html `<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6ZM11 6C11 8.76142 8.76142 11 6 11C4.79932 11 3.69749 10.5768 2.83554 9.8714L9.8714 2.83554C10.5768 3.69749 11 4.79932 11 6ZM2.12845 9.16427L9.16427 2.12845C8.30235 1.42315 7.20059 1 6 1C3.23858 1 1 3.23858 1 6C1 7.20059 1.42315 8.30235 2.12845 9.16427Z" class="svg-bg"/>
</svg>
`;
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 -8.42937e-07 12.4183 0 8C-8.42932e-08 3.58172 3.58172 -8.42937e-08 8 0C12.4183 -1.26441e-07 16 3.58172 16 8ZM14 8C14 11.3137 11.3137 14 8 14C6.70408 14 5.50412 13.5892 4.52327 12.8906L12.8906 4.52327C13.5892 5.50412 14 6.70408 14 8ZM11.4763 3.10911L3.10911 11.4763C2.41074 10.4956 2 9.29574 2 8C2 4.68629 4.68629 2 8 2C9.29574 2 10.4956 2.41074 11.4763 3.10911Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M20.4853 20.4853C15.799 25.1716 8.20101 25.1716 3.51472 20.4853C-1.17157 15.799 -1.17157 8.20101 3.51472 3.51472C8.20101 -1.17157 15.799 -1.17157 20.4853 3.51472C25.1716 8.20101 25.1716 15.799 20.4853 20.4853ZM4.25679 18.3291L18.3291 4.25679C14.4011 1.03827 8.59555 1.26232 4.92893 4.92893C1.26232 8.59554 1.03827 14.4011 4.25679 18.3291ZM5.67101 19.7433C9.59902 22.9617 15.4045 22.7376 19.0711 19.0711C22.7376 15.4045 22.9617 9.59902 19.7433 5.67101L5.67101 19.7433Z" class="svg-bg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M32 16C32 24.8366 24.8366 32 16 32C11.9419 32 8.2366 30.4892 5.41598 27.9994L5.39468 28.0207L4.81507 27.441C4.72874 27.3566 4.64336 27.2713 4.55896 27.1849L3.98047 26.6064L4.0017 26.5852C1.51123 23.7644 0 20.0587 0 16C0 7.16344 7.16344 0 16 0C20.0587 0 23.7644 1.51123 26.5852 4.0017L26.6079 3.97903L28.0221 5.39324L27.9994 5.41598C30.4892 8.2366 32 11.9419 32 16ZM25.1679 5.41905C22.7117 3.28903 19.5064 2 16 2C8.26801 2 2 8.26801 2 16C2 19.5064 3.28903 22.7117 5.41905 25.1679L25.1679 5.41905ZM6.83335 26.582C9.28939 28.7114 12.4942 30 16 30C23.732 30 30 23.732 30 16C30 12.4942 28.7114 9.28939 26.582 6.83335L6.83335 26.582Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonNone is a generated icon component.
 */
let IconCommonNone = IconCommonNone_1 = class IconCommonNone extends IconBaseElement {
    render() {
        return html `${IconCommonNone_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonNone.icons = new Map([
    ['s8', _s12IconSvg],
    ['s12', _s12IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconCommonNone = IconCommonNone_1 = __decorate([
    customElement('zui-icon-common-none')
], IconCommonNone);
export { IconCommonNone };
